import { render, staticRenderFns } from "./bancaChecker.vue?vue&type=template&id=a54e2320&scoped=true"
import script from "./bancaChecker.vue?vue&type=script&lang=js"
export * from "./bancaChecker.vue?vue&type=script&lang=js"
import style0 from "./bancaChecker.vue?vue&type=style&index=0&id=a54e2320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54e2320",
  null
  
)

export default component.exports